import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f8a2978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 2,
  class: "settings"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "sidebar" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "sidebar__item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "active-bar" }),
    /*#__PURE__*/_createTextVNode(" Account "),
    /*#__PURE__*/_createElementVNode("span", { class: "spacer" }),
    /*#__PURE__*/_createElementVNode("span", { class: "iconfont iarrow active-arrow" })
  ])
], -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Device Notifications", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Control notifications on devices where you use Shortform", -1))
const _hoisted_8 = { class: "content__buttons" }
const _hoisted_9 = { class: "content__buttons__row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "settings-email" }, "Account Email", -1))

import { onBeforeMount, ref } from 'vue'

import RootPageLayout from '@/app/components/RootPageLayout.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import { SettingsView } from '@/models/settings'
import { getEmail } from '@/services/auth'
import InfoDeleteAccount from '@/app/components/settings/InfoDeleteAccount.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const settingsView = ref(new SettingsView())
const email = ref<string | null>(null)

async function updateNotifyNewRelease(value: boolean): Promise<void> {
  await settingsView.value.toggleNotificationSetting(
    'notify_new_release',
    value,
  )
}

onBeforeMount(async () => {
  await settingsView.value.init()
  email.value = getEmail()
})

return (_ctx: any,_cache: any) => {
  const _component_LoadingError = _resolveComponent("LoadingError")!

  return (_openBlock(), _createBlock(RootPageLayout, { title: "Settings" }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (settingsView.value.isLoading)
            ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
            : _createCommentVNode("", true),
          (settingsView.value.isError)
            ? (_openBlock(), _createBlock(_component_LoadingError, { key: 1 }))
            : _createCommentVNode("", true),
          (settingsView.value.isLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("ul", _hoisted_8, [
                    _createElementVNode("li", _hoisted_9, [
                      _createVNode(ToggleButton, {
                        class: "toggle-button",
                        value: 
                    settingsView.value.notificationSettings?.notify_new_release ||
                    false
                  ,
                        "onUpdate:value": updateNotifyNewRelease
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" New summary announcements ")
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ]),
                  _hoisted_10,
                  _createElementVNode("p", null, _toDisplayString(email.value), 1),
                  _createVNode(InfoDeleteAccount)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})